import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import    '@/assets/css/common.css';
Vue.config.productionTip = false
import router from "./router/index";
console.log("env:",process.env)
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
